// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__dSDyx","header":"ClearentDisclaimer_header__1qbqe","inner":"ClearentDisclaimer_inner__3npQS"};